// A deadline on a promise, pure so node --test can reach it.
//
// Why the shell needs one (R14): a browser extension in the owner's Chrome stalled a
// lazily loaded module chunk FOREVER. The import() neither resolved nor rejected, so the
// page sat on "Loading …" with no error and no way out but a guess to reload. A load that
// has not settled by the deadline is treated as failed, which puts the Reload button up.

/** The rejection withTimeout gives when time ran out first. `name` is 'TimeoutError'. */
export class LoadTimeoutError extends Error {
  constructor(ms) {
    super(`did not finish within ${ms / 1000} s`);
    this.name = 'TimeoutError';
  }
}

/**
 * Settles like `promise` if it settles within `ms`, else rejects with LoadTimeoutError.
 *
 * The original promise is NOT cancelled (an import() cannot be): whoever holds it still
 * sees its outcome later. Only this wrapper's answer is fixed at the deadline.
 */
export function withTimeout(promise, ms) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new LoadTimeoutError(ms)), ms);
    promise.then(
      (value) => { clearTimeout(timer); resolve(value); },
      (error) => { clearTimeout(timer); reject(error); },
    );
  });
}
